import { Box, Text } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';

import { Contact } from '../../mergeContactsModal.types';
import { CompareContactsTable } from '../compareContactsTable/compareContactsTable';

export type CompareContactsProps = {
  /** The contact that are merged into */
  targetContact: Contact;
  /** The contact that are merged from */
  sourceContact: Contact;
  /** The contact that resembles the merged contact */
  previewContact: User;
};

/** Component that shows a comparison of two users */
export const CompareContacts = ({
  targetContact,
  sourceContact,
  previewContact,
}: CompareContactsProps): JSX.Element => {
  return (
    <>
      <Box margin="0 0 400 0">
        <Text.Paragraph>
          Contact information from all contacts will be combined into one
          unified contact.
        </Text.Paragraph>
      </Box>

      <CompareContactsTable
        contacts={[targetContact, sourceContact]}
        previewContact={previewContact}
      />
    </>
  );
};
